import { template } from "lodash";
import Forms from "../services/Forms";

export default {

    props: ['formId','siteId', 'modalMessage', 'locale', 'questions', 'captcha'],

    data: () => { return {
        messageStyle: 'none',
        isLoading: false,
        isSubmitted: false,
        error: null,
        response: {},
        answers: {},
        value: null,
        formQuestionsOptions: {},
        toggleAnswers: true,
        validateFormFields: false,
        captchaHasLoaded: false,
        grecaptcha: null,
        captchaToken: null,
    }},

    beforeMount() {
        Object.values(this.questions).forEach(question => {
            if(question.field_type === 'multiple_answers'){
                this.addMoreAnswers(question.id)
            }

            this.formQuestionsOptions[question.id] = {}
            if(question.field_type === 'choice' || question.field_type === 'multiple_choice'){
                this.formQuestionsOptions[question.id] = question.metadata.choices.map((choice) => {
                    return {'value' : choice.value , 'text': choice.text[this.locale] }
                })
            }
        });

        let captchaScript = document.createElement('script');
            captchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + this.captcha
            captchaScript.onload = this.captchaLoaded;
            document.body.appendChild(captchaScript)
    },

    methods: {
        captchaLoaded: function (event) {
            this.captchaHasLoaded = true
            this.grecaptcha = grecaptcha;
        },
        startFormValidation: function () {
            this.validateFormFields = true;
            setTimeout(() => {
                let firstError =  document.querySelector('select:invalid');
                if(firstError === null) {
                    firstError = document.querySelector('input:invalid');
                }

                if(firstError !== null) {
                    firstError.scrollIntoView({ block: "end", behavior: "smooth" });
                }

            },100)
        },

        onSubmit: function(token) {

            this.error = null;
            this.scrollToMessage();

            this.response.siteid = this.siteId;
            this.response.captchaToken = token;

            Forms.Submit(this.formId, {response: this.response})
                .then((res) => {
                    this.isLoading = false;
                    if(this.modalMessage){
                        $('#modalMessageAfterSent' + this.formId).modal();
                    }else{
                        this.isSubmitted = true;
                        this.scrollToMessage();
                    }
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.isSubmitted = false;
                    this.error = err;
                    this.scrollToMessage();
                })
        },

        scrollToMessage: function() {
            this.messageStyle = 'block';
            document.querySelector('#messages-' + this.formId)
                .scrollIntoView({ behavior: 'smooth' });
        },

        finQuestion: function (id){
            return Object.values(this.questions).find((question) => {
                if(question.id === id){
                    return question
                }
            })
        },

        addMoreAnswers(questionId){

            let question = this.finQuestion(questionId);

            if(this.answers[question.id] === undefined || question.metadata !== null) {
                console.warn('Question not found')
            }

            let metadata = question.metadata.answers;

            if(this.response[questionId] === undefined){
                this.response[questionId] = [];
            }

            let metadataMapEmpty = {};
            Object.values(metadata).forEach((index) => {
                metadataMapEmpty[index.value] = '';
            });

            this.response[questionId].push(metadataMapEmpty);

            this.$forceUpdate();

        },

        removeAnswers(questionId, index){
            this.response[questionId].splice(index, 1);
            //document.getElementById('question-' + questionId +'-' + index + '-holder').remove();
            this.$forceUpdate();
        },

        verifyDependentQuestion(questionId){

            let question = Object.values(this.questions).find((qt) => qt.id === questionId);
            if (question === undefined) {
                console.warn('[SapphireCMS] Question not found');
                return true;
            }

            if(question.depends_on === null) {
                return true;
            }

            if(this.response[question.depends_on] === undefined) {
                return false;
            }

            let dependentQuestion = Object.values(this.questions).find((qtf) => qtf.id === question.depends_on)
            if (dependentQuestion === undefined) {
                console.warn('[SapphireCMS] Question Father not found');
                return true;
            }

            let statusToValidate = this.response[question.depends_on];
            if(dependentQuestion.field_type === 'boolean' && typeof(this.response[question.depends_on]) === 'object') {
                statusToValidate = this.response[question.depends_on].join()
            }

            if(dependentQuestion.field_type === 'boolean' && typeof(this.response[question.depends_on]) === 'boolean') {
                statusToValidate = this.response[question.depends_on] + '';
            }

            return question.depends_on_status === statusToValidate;

        },
         getCaptchaToken: async function () {
             this.grecaptcha.ready(() =>{
                 this.isLoading = true;
                 this.grecaptcha.execute(this.captcha, {action: 'submit'}).then((token) => {
                     this.onSubmit(token)
                 });
             });

         }
    }

}
